import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=39094130&scoped=true"
import script from "./Errors.vue?vue&type=script&lang=ts"
export * from "./Errors.vue?vue&type=script&lang=ts"
import style0 from "./Errors.vue?vue&type=style&index=0&id=39094130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39094130",
  null
  
)

export default component.exports